import React, { ReactNode } from 'react';
import cx from 'classnames';

import './empty-state-overlay.css';

interface EmptyStateOverlayProps {
    addMargin?: boolean;
    children: ReactNode;
    height?: number;
    width?: number;
}

export const EmptyStateOverlay = ({
    addMargin = true,
    children,
    height = 350,
    width = 800,
}: EmptyStateOverlayProps): JSX.Element => (
    <div className={cx({ 'ml-12 mt-16': addMargin })}>
        <div
            className="empty-state-overlay rounded-lg"
            style={{
                width,
                height,
            }}
        >
            {children}
        </div>
    </div>
);
